import { MarketplaceAssetSelectablePrice, MarketplaceBundleMetadata, MarketplacePrice } from '@/lib/marketplace/types'

export const formatMarketplacePrice = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export const formatMarketplacePriceWithoutCents = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export const shouldSendExplicitAssetPriceId = (price?: MarketplaceAssetSelectablePrice | null) => {
  if (!price) {
    return undefined
  }

  return price.is_default ? undefined : price.id
}

export const getMarketplaceDisplayPrice = (
  price?: MarketplacePrice | MarketplaceAssetSelectablePrice | null
) => {
  if (!price) {
    return null
  }

  return formatMarketplacePriceWithoutCents(price.amount, price.currency)
}

export const getBundleMetadataValue = <T>(metadata: MarketplaceBundleMetadata, key: string): T | null => {
  const rawValue = metadata[key]

  if (!rawValue) {
    return null
  }

  if (typeof rawValue === 'object' && rawValue !== null && 'value' in rawValue) {
    return (rawValue as { value: T }).value
  }

  return rawValue as T
}

export const getBundleCardImage = (metadata: MarketplaceBundleMetadata) => {
  return getBundleMetadataValue<string>(metadata, 'bundle_card_img') ?? getBundleMetadataValue<string>(metadata, 'portal_pic')
}
